<template lang="pug">
.child-icon
  img(src="~assets/avatar-null.svg")
</template>
<script>
export default {
  name: 'ChildIcon',
  props: {},
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.child-icon
  width: 100%
  height: 100%
  background: white
  border-radius: 50%
  +flex-center
  img
    width: 70%
</style>
